export type TextStats = {
  words: number;
  chars: number;
};

/** Word and character counts for raw text preview (e.g. LLM log modal). */
export function getTextStats(text: string): TextStats {
  const chars = text.length;
  const trimmed = text.trim();
  const words = trimmed.length === 0 ? 0 : trimmed.split(/\s+/).length;
  return { words, chars };
}
